import { render, staticRenderFns } from "./WarehouseConstructionPortlet.vue?vue&type=template&id=7241512a&"
import script from "./WarehouseConstructionPortlet.vue?vue&type=script&lang=js&"
export * from "./WarehouseConstructionPortlet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports